// extracted by mini-css-extract-plugin
export default {"title":"j4-z","warning":"k4-z","sizeOptionsLegendText":"l4-z"};